import { getExecutingEnvironment } from "@app/resolveModule/env";
import type { ClientWorkspaceConfig } from "@ext/workspace/WorkspaceConfig";

export const needsGesCloudWorkspaceInit = (isGesCloudEnabled: boolean, workspaces: ClientWorkspaceConfig[]) =>
	getExecutingEnvironment() === "web" &&
	isGesCloudEnabled &&
	!workspaces.some((workspace) => workspace.enterpriseCloud?.url);
